import React from "react";
import Popup from "components/common/Popup";

export default () => (
  <Popup contentLabel="Reload page popup" isOpen={true}>
    <div className="popup-content">The website has been updated - please reload the page.</div>
  </Popup>
);
